import React from "react";
import styles from "../component/custom.module.css";
import Carousel from "better-react-carousel";
import Images from "./Images";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper";

const data = [
  {
    image: Images.MaliniImg,
    author: {
      name: "Malini Agarwal",
      bio: "Founder & Creative Director of MissMalini Entertainment & Malini's Girl Tribe, Co founder of Good Creator Co. Author and TV Host",
    },
  },
];

const JurySlider = ({ JurySelect }) => {
  return (
    <section className={styles.sliderSection} ref={JurySelect}>
      <div className="container-fluid">
        <h2>Our Jury</h2>
        <div className={styles.sliderJury}>
          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            loop={true}
            spaceBetween={20}
            slidesPerView={3}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true, // Enable clickable pagination bullets
              // el: ".swiper-pagination", // Element to render pagination bullets
            }}
            breakpoints={{
              300: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            navigation={true}
            style={{
              "--itemsCount": 5,
            }}
          >
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    className={styles.sliderProfileImg}
                    src={Images.sagarik_thumnail}
                    loading="lazy"
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Sagarika Ghatge</p>
                    <span>
                      Actor, Entrepreneur &amp; Founder of Akutee

                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    className={styles.sliderProfileImg}
                    src={Images.naila_thumnail}
                    loading="lazy"
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Naila Grrewal</p>
                    <span>
                      Actor
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    className={styles.sliderProfileImg}
                    src={Images.soha_thumnail}
                    loading="lazy"
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Soha Ali Khan</p>
                    <span>
                      Actor, Author
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    className={styles.sliderProfileImg}
                    src={Images.divyaDutta}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Ms. Divya Dutta</p>
                    <span>
                      Actor Poet And Author
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img class={styles.sliderProfileImg} src={Images.kirtImg} />
                  <div className={styles.sliderInnerInfo}>
                    <p>Mr. Kirti Ashar</p>
                    <span>Charak Pharma Pvt. Ltd. </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    class={styles.sliderProfileImg}
                    src={Images.SussanneKhan}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Ms. Sussanne Khan</p>
                    <span>
                      Creative Director & Founder of The Charcoal Project
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    class={styles.sliderProfileImg}
                    src={Images.ManyaSingh}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Ms. Manya Singh</p>
                    <span>Former Femina Miss India - 2020</span>
                  </div>
                </div>
              </div>
            </SwiperSlide> */}
            {/* <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    class={styles.sliderProfileImg}
                    src={Images.SHINYDOSHIImg}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Shiny Doshi</p>
                    <span>Indian Actor</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    class={styles.sliderProfileImg}
                    src={Images.RuchitaImg}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Ruchita Dar Shah</p>
                    <span>Founder & CEO, Firstmomsclub </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.sliderMain}>
                <div className={styles.sliderInner}>
                  <img
                    class={styles.sliderProfileImg}
                    src={Images.SHINYDOSHIImg}
                  />
                  <div className={styles.sliderInnerInfo}>
                    <p>Shiny Doshi</p>
                    <span>Indian Actor</span>
                  </div>
                </div>
              </div>
            </SwiperSlide> */}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default JurySlider;
